"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _splitToWords = _interopRequireDefault(require("./splitToWords"));

var insertGap = function insertGap(values, gap) {
  var array = (0, _splitToWords.default)(values);

  if (array) {
    return array.map(function (col, i, arr) {
      return gap && i + 1 < arr.length ? "".concat(col, " ").concat(gap) : col;
    }).join(" ");
  }

  return undefined;
};

var _default = insertGap;
exports.default = _default;